import(/* webpackMode: "eager" */ "/vercel/path0/src/app/carte/page.tsx");
